import React from 'react'
import { Alert, Snackbar } from '@mui/material'
import { useStore } from '@/src/types/store'

const GlobalToast = () => {
  const { toastOpen, toastMessage, toastType, toastDuration, closeToast } = useStore()

  return (
    <Snackbar
      open={toastOpen}
      autoHideDuration={toastDuration}
      onClose={closeToast}
      anchorOrigin={{
        vertical: 'bottom',
        horizontal: 'right'
      }}
    >
      <Alert onClose={closeToast} severity={toastType} variant="filled" sx={{ width: '100%' }}>
        {toastMessage}
      </Alert>
    </Snackbar>
  )
}

export default GlobalToast
